import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import axios from "axios";
import axiosInstance from '../../api/axiosInstance';
import { RESTRICTED_ACCESS_STORAGE_KEY } from './restrictedAccessSlice';
import { clearSession, hasValidSession } from '../../auth/session';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export const loginUser = createAsyncThunk(
    "loginUser",
    async ({ email, password }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/api/v1/hotel/login`, {
                email,
                password,
            });
            // console.log("login api response", response);
            const { data } = response.data;
            // console.log("login data===", data);
            return data;
        } catch (error) {
            console.log("login error : ", error);
            return rejectWithValue(error.response.data);
        }
    },
);

export const signupUser = createAsyncThunk(
    "signupUser",
    async ({ email, password }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `/api/v1/hotel/signup`,
                {
                    email,
                    password,
                },
            );
            // console.log("signup api response", response);
            const { data } = response.data;
            // console.log("signup data===", data);
            return data;
        } catch (err) {
            console.log("signup error", err);
            return rejectWithValue(err.response.data);
        }
    },
);

const authSlice = createSlice({
    name: "auth",
    initialState: {
        data: null,
        isError: false,
        isAuthenticated: hasValidSession(),
    },
    reducers: {
        logout: (state) => {
            state.data = null;
            state.isError = false;
            state.isAuthenticated = false;
            clearSession();
        },
    },
    extraReducers: (builder) => {
        //Login use cases
        builder.addCase(loginUser.pending, (state, action) => {
            state.data = null;
        });
        builder.addCase(loginUser.fulfilled, (state, action) => {
            state.data = action.payload;
            state.isAuthenticated = true;
            state.errorMessage = "";
            const { hotel_id, token } = action.payload;
            localStorage.setItem("token", token);
            localStorage.setItem("hotelId", hotel_id);
            sessionStorage.removeItem(RESTRICTED_ACCESS_STORAGE_KEY);
        });
        builder.addCase(loginUser.rejected, (state, action) => {
            console.log("Login Error : ", action.payload);
            state.isError = true;
            state.errorMessage = action.payload?.message || "Login failed";
            state.isAuthenticated = false;
        });

        //Signup user cases
        builder.addCase(signupUser.pending, (state, action) => {
            state.data = null;
        });
        builder.addCase(signupUser.fulfilled, (state, action) => {
            state.data = action.data;
            state.isAuthenticated = true;
            const { hotel_id, token } = action.payload;
            state.errorMessage = "";
            localStorage.setItem("token", token);
            localStorage.setItem("hotelId", hotel_id);
            sessionStorage.removeItem(RESTRICTED_ACCESS_STORAGE_KEY);
        });
        builder.addCase(signupUser.rejected, (state, action) => {
            console.log("Signup Error:", action.payload);
            state.isError = true;
            state.errorMessage = action.payload?.message || "Signup failed";
            state.isAuthenticated = false;
        });
    },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
